import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import HomeIcon from '@mui/icons-material/Home';
import PersonIcon from '@mui/icons-material/Person';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import DashboardIcon from '@mui/icons-material/Dashboard';
import GridOnIcon from '@mui/icons-material/GridOn';
import LogoutIcon from '@mui/icons-material/Logout';
import AddIcon from '@mui/icons-material/Add';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import RoomPreferencesIcon from '@mui/icons-material/RoomPreferences';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import SubtitlesOffIcon from '@mui/icons-material/SubtitlesOff';
import BackspaceIcon from '@mui/icons-material/Backspace';
import LockIcon from '@mui/icons-material/Lock';
import DialpadIcon from '@mui/icons-material/Dialpad';
import SearchIcon from '@mui/icons-material/Search';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import SyncIcon from '@mui/icons-material/Sync';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import Tag from '@mui/icons-material/LocalOffer';
import CancelIcon from '@mui/icons-material/Cancel';
import ReplyIcon from '@mui/icons-material/Reply';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import NotificationsIcon from '@mui/icons-material/Notifications';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import JuiceIcon from '@mui/icons-material/WineBar';
import RestaurantMenuIcon from '@mui/icons-material/RestaurantMenu';
import TakeoutDiningIcon from '@mui/icons-material/TakeoutDining';
import DeliveryDiningIcon from '@mui/icons-material/DeliveryDining';
import RoomServiceIcon from '@mui/icons-material/RoomService';
import AlarmIcon from '@mui/icons-material/Alarm';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PendingIcon from '@mui/icons-material/Pending';
import Pendingreceipt from '@mui/icons-material/PendingActions';
import HeadsetMicIcon from '@mui/icons-material/HeadsetMic';
import AdvanceList from '@mui/icons-material/ListAlt';
import NewTrip from '@mui/icons-material/Luggage';
import checkin from '@mui/icons-material/HowToReg';
import Status from '@mui/icons-material/WorkHistory';
import Report from '@mui/icons-material/Assignment';
import Closecalender from '@mui/icons-material/EventBusy';
import MessageIcon from '@mui/icons-material/Message';
import AppsIcon from '@mui/icons-material/Apps';
import Reservations from '@mui/icons-material/EventAvailable';
import Groups2Icon from '@mui/icons-material/Groups2';
import PaymentsIcon from '@mui/icons-material/Payments';
import Dollar from '@mui/icons-material/AttachMoney';
import Tasktable from '@mui/icons-material/Shortcut';
import TokenIcon from '@mui/icons-material/Token';
import DisabledByDefaultIcon from '@mui/icons-material/DisabledByDefault';
import TodayIcon from '@mui/icons-material/Today';
import SettingsIcon from '@mui/icons-material/Settings';
import ForumIcon from '@mui/icons-material/Forum';
import GTranslateIcon from '@mui/icons-material/GTranslate';
import EditNoteIcon from '@mui/icons-material/EditNote';
import TableRestaurantIcon from '@mui/icons-material/TableRestaurant';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Threedot from '@mui/icons-material/MoreVert';
import Dice from '@mui/icons-material/Casino';
import FastfoodIcon from '@mui/icons-material/Fastfood';
import CloseIcon from '@mui/icons-material/Close';
import AppleIcon from '@mui/icons-material/Apple';
import Car from '@mui/icons-material/DirectionsCarFilled';
import VisibilityIcon from '@mui/icons-material/Visibility';
import SoupKitchenIcon from '@mui/icons-material/SoupKitchen';
import Chair from '@mui/icons-material/ChairAlt';
import FireplaceIcon from '@mui/icons-material/Fireplace';
import DeleteIcon from '@mui/icons-material/Delete';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import FormatColorFillIcon from '@mui/icons-material/FormatColorFill';
import DiscountIcon from '@mui/icons-material/Discount';
import Hold from '@mui/icons-material/HourglassTop';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import PrintIcon from '@mui/icons-material/Print';
import Modification from '@mui/icons-material/NoteAlt';
import LoyaltyIcon from '@mui/icons-material/Loyalty';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import Surcharge from '@mui/icons-material/LocalAtm';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import ReadyOrder from '@mui/icons-material/Grading';
import Minus from '@mui/icons-material/Remove';
import InboxIcon from '@mui/icons-material/Inbox';
import SendIcon from '@mui/icons-material/Send';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import Reservation from '@mui/icons-material/EventAvailable';
import GroupsIcon from '@mui/icons-material/Groups';
import Cashin from '@mui/icons-material/MonetizationOn';
import RedoIcon from '@mui/icons-material/Redo';
import PercentIcon from '@mui/icons-material/Percent';
import ComputerIcon from '@mui/icons-material/Computer';
import LocalPizzaIcon from '@mui/icons-material/LocalPizza';
import ScreenLockLandscapeIcon from '@mui/icons-material/ScreenLockLandscape';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ToolsIcon from '@mui/icons-material/Construction';
import MaintananceIcon from '@mui/icons-material/Engineering';
import OutletIcon from '@mui/icons-material/Outlet';
import SortByAlphaIcon from '@mui/icons-material/SortByAlpha';
import RemoveIcon from '@mui/icons-material/Remove';
import ScreenRotationAltIcon from '@mui/icons-material/ScreenRotationAlt';
import BackupIcon from '@mui/icons-material/Backup';
import RestoreIcon from '@mui/icons-material/Restore';
import SplitIcon from '@mui/icons-material/HorizontalSplit';
import RefreshIcon from '@mui/icons-material/Refresh';
import ChecklistIcon from '@mui/icons-material/Checklist';
import UndoIcon from '@mui/icons-material/Undo';
import RocketLaunchIcon from '@mui/icons-material/RocketLaunch';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import FeedbackIcon from '@mui/icons-material/Feedback';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import PhonelinkRingIcon from '@mui/icons-material/PhonelinkRing';
import ContactPhoneIcon from '@mui/icons-material/ContactPhone';
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ViewListIcon from '@mui/icons-material/ViewList';
export const WSIcons = {
    Edit: EditOutlinedIcon,
    Home:HomeIcon,
    Hold:Hold,ComputerIcon:ComputerIcon,
    SendIcon:SendIcon,
    ViewListIcon:ViewListIcon,
    RefreshIcon:RefreshIcon,
    ArrowDropDownIcon:ArrowDropDownIcon,
    InboxIcon:InboxIcon,
    ToolsIcon:ToolsIcon,
    Person:PersonIcon,
    UndoIcon:UndoIcon,
    ExpandMoreIcon:ExpandMoreIcon,
    ExpandLessIcon:ExpandLessIcon,
    FeedbackIcon:FeedbackIcon,
    ChecklistIcon:ChecklistIcon,
    SplitIcon:SplitIcon,
    RestoreIcon:RestoreIcon,
    LocalLibraryIcon:LocalLibraryIcon,
    ContactPhoneIcon:ContactPhoneIcon,
    RocketLaunchIcon:RocketLaunchIcon,
    BackupIcon:BackupIcon,
    VerifiedUserIcon:VerifiedUserIcon,
    SupportAgentIcon:SupportAgentIcon,
    MaintananceIcon:MaintananceIcon,
    ChevronRightIcon,
    SortByAlphaIcon:SortByAlphaIcon,
    RemoveIcon:RemoveIcon,
    LocalPizzaIcon:LocalPizzaIcon,
    Threedot:Threedot,
    OutletIcon:OutletIcon,
    Car:Car,
    PhonelinkRingIcon:PhonelinkRingIcon,
    QuestionAnswerIcon:QuestionAnswerIcon,
    ScreenRotationAltIcon:ScreenRotationAltIcon,
    ScreenLockLandscapeIcon:ScreenLockLandscapeIcon,
    RedoIcon:RedoIcon,
    Cashin:Cashin,
    GroupsIcon:GroupsIcon,
    Reservation:Reservation,
    ReadyOrder:ReadyOrder,
    VisibilityOffIcon:VisibilityOffIcon,
    FormatListBulletedIcon:FormatListBulletedIcon,
    FilterAltIcon:FilterAltIcon,
    Modification:Modification,
    CreditCardIcon:CreditCardIcon,
    DeleteIcon:DeleteIcon,
    Chair:Chair,
    LoyaltyIcon:LoyaltyIcon,
    PendingActionsIcon:PendingActionsIcon,
    FireplaceIcon:FireplaceIcon,
    TrendingUp: TrendingUpIcon,
    Dashboard:DashboardIcon,
    AppleIcon:AppleIcon,
    PercentIcon:PercentIcon,
    KeyboardArrowUpIcon:KeyboardArrowUpIcon,
    KeyboardArrowDownIcon:KeyboardArrowDownIcon,
    Masters:GridOnIcon,
    LogOut:LogoutIcon,
    AddIcon:AddIcon,
    CloseIcon:CloseIcon,
    UserGroup:GroupAddIcon,
    RolesIcon:RoomPreferencesIcon,
    ManageAccountIcon:ManageAccountsIcon,
    MedicalServicesIcon:MedicalServicesIcon,
    SubtitlesOffIcon:SubtitlesOffIcon,
    BackspaceIcon:BackspaceIcon,
    LockIcon:LockIcon,
    DiscountIcon:DiscountIcon,
    DialpadIcon:DialpadIcon,
    SearchIcon:SearchIcon,
    CardGiftcardIcon:CardGiftcardIcon,
    SyncIcon:SyncIcon,
    Surcharge:Surcharge,
    AltRouteIcon:AltRouteIcon,
    Tag:Tag,
    PrintIcon:PrintIcon,
    CancelIcon:CancelIcon,
    ReplyIcon:ReplyIcon,
    Minus:Minus,
    AccountCircleIcon:AccountCircleIcon,
    NotificationsIcon:NotificationsIcon,
    RestaurantIcon:RestaurantIcon,
    JuiceIcon:JuiceIcon,
    RestaurantMenuIcon:RestaurantMenuIcon,
    TakeoutDiningIcon:TakeoutDiningIcon,
    DeliveryDiningIcon:DeliveryDiningIcon,
    RoomServiceIcon:RoomServiceIcon,
    AlarmIcon:AlarmIcon,
    ReceiptIcon:ReceiptIcon,
    ReceiptLongIcon:ReceiptLongIcon,
    PendingIcon:PendingIcon,
    Pendingreceipt:Pendingreceipt,
    HeadsetMicIcon:HeadsetMicIcon,
    AdvanceList:AdvanceList,
    NewTrip:NewTrip,
    checkin:checkin,
    Status:Status,
    Report:Report,
    Closecalender:Closecalender,
    MessageIcon:MessageIcon,
    AppsIcon:AppsIcon,
    Reservations:Reservations,
    Groups2Icon:Groups2Icon,
    PaymentsIcon:PaymentsIcon,
    Dollar:Dollar,
    Tasktable:Tasktable,
    TokenIcon:TokenIcon,
    DisabledByDefaultIcon:DisabledByDefaultIcon,
    TodayIcon:TodayIcon,
    SettingsIcon:SettingsIcon,
    ForumIcon:ForumIcon,
    GTranslateIcon:GTranslateIcon,
    EditNoteIcon:EditNoteIcon,
    TableRestaurantIcon:TableRestaurantIcon,
    KeyboardArrowLeftIcon:KeyboardArrowLeftIcon,
    Dice:Dice,
    FastfoodIcon:FastfoodIcon,
    VisibilityIcon:VisibilityIcon,
    SoupKitchenIcon:SoupKitchenIcon,
    FormatColorFillIcon:FormatColorFillIcon,
    MenuIcon:MenuIcon,
  };
  